
import { Vue, Component, Prop } from 'vue-property-decorator';
import PaymentInfo from '@/features/shipment/components/checkout/PaymentInfo.vue';

@Component({
  components: {
    PaymentInfo,
  },
})
export default class DetailsFoldout extends Vue {
  @Prop({ required: true }) showDetails!: boolean;
}
